<template>
    <BannerList
        v-if="items && items.length"
        :items="items"
    />
    <p v-else>
        There are no sections related to this page right now.
        <nuxt-link to="/sections"> See all sections </nuxt-link>
    </p>
</template>

<script setup>
import relatedSectionsQuery from '~/graphql/queries/sections/Sections.graphql';

const props = defineProps({
    relatedToEntryId: {
        type: [Number, String],
        required: false,
        default: null,
    },
    relatedToTagId: {
        type: [Number, String],
        required: false,
        default: null,
    },
});

const { variables } = useCraftVariables();

variables.limit = 3;

if (props.relatedToEntryId) {
    variables.relatedToEntries = [{ id: props.relatedToEntryId }];
}
if (props.relatedToTagId) {
    variables.relatedToTags = [{ id: props.relatedToTagId }];
}

const { data } = await useLazyAsyncQuery({
    query: relatedSectionsQuery,
    variables,
});

const items = computed(() => {
    return data.value?.entries || [];
});
</script>
